export var RadioButtonTheme;
(function (RadioButtonTheme) {
    RadioButtonTheme["Default"] = "default";
    RadioButtonTheme["Box"] = "box";
})(RadioButtonTheme || (RadioButtonTheme = {}));
export var RadioButtonDataKeys;
(function (RadioButtonDataKeys) {
    RadioButtonDataKeys["Disabled"] = "data-disabled";
    RadioButtonDataKeys["Checked"] = "data-checked";
    RadioButtonDataKeys["Focused"] = "data-focused";
    RadioButtonDataKeys["Required"] = "data-required";
})(RadioButtonDataKeys || (RadioButtonDataKeys = {}));
export var RadioButtonDataHooks;
(function (RadioButtonDataHooks) {
    RadioButtonDataHooks["RadioButtonWrapper"] = "radiobutton-wrapper";
    RadioButtonDataHooks["IconWrapper"] = "icon-wrapper";
    RadioButtonDataHooks["LabelWrapper"] = "label-wrapper";
    RadioButtonDataHooks["coreRadioButton"] = "core-radio-button";
    RadioButtonDataHooks["SubtextWrapper"] = "subtext-wrapper";
})(RadioButtonDataHooks || (RadioButtonDataHooks = {}));
//# sourceMappingURL=types.js.map